import { render, staticRenderFns } from "./BaseAttrDisplayText.vue?vue&type=template&id=fc6d391e&functional=true"
import script from "./BaseAttrDisplayText.vue?vue&type=script&lang=js"
export * from "./BaseAttrDisplayText.vue?vue&type=script&lang=js"
import style0 from "./BaseAttrDisplayText.vue?vue&type=style&index=0&id=fc6d391e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports